import { type CarrierDef } from '../common.js'
import { accountNumber, password, username, userPassMap } from '../internal.js'

const credentialTypes = [username, password] as const
const locationCredentialTypes = [accountNumber] as const

export type hrcfCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]

export const hrcf: CarrierDef<hrcfCredType> = {
  name: 'Hercules Freight',
  scac: 'hrcf',
  credentialTypes,
  locationCredentialTypes,
  legacyCredMap: [...userPassMap, ['account-number', 'ref1']],
  engineLayers: ['rating', 'pickup', 'tracking'],
  credentialConfig: {
    'account-number': { customerIdentifier: true },
  },
}
